
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.visually-hidden{clip-path:inset(50%);height:1px;overflow:hidden;position:absolute!important;width:1px}table{border-collapse:collapse;width:100%}tr{border-top:1px solid var(--black-450);display:flex;flex-direction:column}.desktop tr{display:table-row}td.event-time{display:flex;flex-wrap:nowrap;font-weight:var(--fw-semibold);padding:.75rem 0 0;width:100%}.desktop td.event-time{padding:.75rem 2rem .75rem 0;width:-moz-max-content;width:max-content}td.event-info{padding:.75rem 0;width:100%}.main-wrapper{padding-top:var(--spacing-8)}`;